declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

export function initMetaPixel() {
  try {
    if (typeof window === 'undefined' || window.fbq) return

    const n: any = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })

    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const t = document.createElement('script')
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(t)

    window.fbq('init', '1438495414738821')
    window.fbq('track', 'PageView')
  } catch (e) {
    // Pixel may fail in sandboxed environments — silently ignore
    console.warn('Meta Pixel initialization skipped:', e)
  }
}

export function trackAddToCart() {
  try {
    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'AddToCart')
    }
  } catch (e) {
    console.warn('Meta Pixel event skipped:', e)
  }
}
